import { render } from "./vueTable.vue?vue&type=template&id=68a03ea7&scoped=true"
import script from "./vueTable.vue?vue&type=script&lang=js"
export * from "./vueTable.vue?vue&type=script&lang=js"

import "./vueTable.vue?vue&type=style&index=0&id=68a03ea7&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a03ea7"]])

export default __exports__